import React, { useEffect, useRef } from "react";
import "./DraftResumePrompt.scss";

const DraftResumePrompt = ({
  open,
  title = "Є незавершене оголошення",
  subtitle = "Схоже, ви вже починали це оголошення. Продовжимо з того місця чи почнемо спочатку?",
  meta = "",
  onResume,
  onDiscard,
  onClose,
}) => {
  const boxRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onEsc = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onEsc);
    return () => document.removeEventListener("keydown", onEsc);
  }, [open, onClose]);

  useEffect(() => {
    if (open) {
      requestAnimationFrame(() => {
        boxRef.current?.focus?.();
      });
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="draft-resume-overlay" role="dialog" aria-modal="true">
      <button
        type="button"
        className="draft-resume-backdrop"
        onClick={onClose}
        aria-label="Закрити"
        title="Закрити"
      />

      <div className="draft-resume-card" ref={boxRef} tabIndex={-1} role="document">
        <div className="draft-resume-head">
          <div className="draft-resume-title">{title}</div>
          <button
            type="button"
            className="draft-resume-x"
            onClick={onClose}
            aria-label="Закрити"
            title="Закрити"
          >
            ×
          </button>
        </div>

        <div className="draft-resume-sub">{subtitle}</div>

        {meta ? <div className="draft-resume-meta">{meta}</div> : null}

        <div className="draft-resume-actions">
          <button
            type="button"
            className="draft-btn draft-btn-secondary"
            onClick={onDiscard}
          >
            Почати спочатку
          </button>
          <button
            type="button"
            className="draft-btn draft-btn-primary"
            onClick={onResume}
          >
            Продовжити
          </button>
        </div>
      </div>
    </div>
  );
};

export default DraftResumePrompt;
